import { render } from "./qontak.svg?vue&type=template&id=4e4d2328"
const script = {}
script.render = render

export default script